import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/redux/Store';
import type { ChatMessage } from '@/redux/slices/chatSlice';
import { getMediaUrl } from '@/constants/media';
import { profileLink } from '@/utils/profileLink';
import './ChatMessageBubble.scss';

interface Props {
  message: ChatMessage;
}

const ChatMessageBubble: React.FC<Props> = ({ message }) => {
  const navigate = useNavigate();
  const currentUserId = useAppSelector((s) => s.auth?.user?.id);
  const isOwn = message.userId === currentUserId;

  const formattedTime = new Date(message.createdAt).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  if (message.isMegaphone) {
    return (
      <div className="chat-megaphone-bubble">
        <span className="chat-megaphone-bubble__icon">📣</span>
        <div className="chat-megaphone-bubble__content">
          <button
            className="chat-megaphone-bubble__author"
            onClick={() => navigate(profileLink(message.username, 'chat'))}
          >
            {message.displayName}
          </button>
          <p className="chat-megaphone-bubble__body">{message.body}</p>
        </div>
        <span className="chat-megaphone-bubble__time">{formattedTime}</span>
      </div>
    );
  }

  return (
    <div className={`chat-msg ${isOwn ? 'chat-msg--own' : ''}`}>
      {!isOwn && (
        <button
          className="chat-msg__avatar-wrap"
          onClick={() => navigate(profileLink(message.username, 'chat'))}
          title={message.displayName}
        >
          {message.avatar ? (
            <img
              src={getMediaUrl(message.avatar) ?? undefined}
              alt={message.displayName}
              className="chat-msg__avatar"
            />
          ) : (
            <div className="chat-msg__avatar chat-msg__avatar--placeholder">
              {message.displayName[0]?.toUpperCase()}
            </div>
          )}
        </button>
      )}
      <div className="chat-msg__content">
        {!isOwn && (
          <button
            className="chat-msg__author"
            onClick={() => navigate(profileLink(message.username, 'chat'))}
          >
            {message.displayName}
          </button>
        )}
        <div className="chat-msg__bubble">
          <span className="chat-msg__text">{message.body}</span>
          <span className="chat-msg__time">{formattedTime}</span>
        </div>
      </div>
    </div>
  );
};

export default ChatMessageBubble;
